import React, { FunctionComponent } from 'react';
import { Bar } from '../Bar';
import { Header } from '../Header';
import classnames from 'classnames';

import styles from './main.scss';

type BarHeaderProps = {
    size?: 'small' | 'medium' | 'large' | 'xLarge' | 'xxLarge';
    dataTn?: string;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    htmlElementType?: 'div' | 'h1' | 'h2';
    type?: 'trade' | 'default';
};

export const BarHeader: FunctionComponent<BarHeaderProps> = props => {
    const {
        size = 'large',
        title,
        subtitle,
        dataTn,
        htmlElementType = 'div',
        type = 'default',
    } = props;

    return (
        <div
            className={classnames(styles.headerWrapper, styles[size])}
            data-tn={`bar-header${dataTn ? `-${dataTn}` : ''}`}
        >
            <Header
                title={title}
                subtitle={subtitle}
                htmlElementType={htmlElementType}
                size={size}
                dataTn={dataTn}
            />
            <Bar size={size} type={type} />
        </div>
    );
};
